const alertFilled: object = {
  "blue-gray": {
    backgroud: "bg-blue-gray-500",
    color: "text-white",
  },
  gray: {
    backgroud: "bg-gray-500",
    color: "text-white",
  },
  brown: {
    backgroud: "bg-brown-500",
    color: "text-white",
  },
  "deep-orange": {
    backgroud: "bg-deep-orange-500",
    color: "text-white",
  },
  orange: {
    backgroud: "bg-orange-500",
    color: "text-white",
  },
  amber: {
    backgroud: "bg-amber-500",
    color: "text-black",
  },
  yellow: {
    backgroud: "bg-yellow-500",
    color: "text-black",
  },
  lime: {
    backgroud: "bg-lime-500",
    color: "text-black",
  },
  "light-green": {
    backgroud: "bg-light-green-500",
    color: "text-white",
  },
  green: {
    backgroud: "bg-green-500",
    color: "text-white",
  },
  teal: {
    backgroud: "bg-teal-500",
    color: "text-white",
  },
  cyan: {
    backgroud: "bg-cyan-500",
    color: "text-white",
  },
  "light-blue": {
    backgroud: "bg-light-blue-500",
    color: "text-white",
  },
  blue: {
    backgroud: "bg-blue-500",
    color: "text-white",
  },
  indigo: {
    backgroud: "bg-indigo-500",
    color: "text-white",
  },
  "deep-purple": {
    backgroud: "bg-deep-purple-500",
    color: "text-white",
  },
  purple: {
    backgroud: "bg-purple-500",
    color: "text-white",
  },
  pink: {
    backgroud: "bg-pink-500",
    color: "text-white",
  },
  red: {
    backgroud: "bg-red-500",
    color: "text-white",
  },
};

export default alertFilled;
